import CompositeTableSearchControls from "@/appComponents/Blocks/Composites/CompositeChartSearch/CompositeTableSearchControls";
import {
  usePlanningTabularContext,
  useTableInstanceContext
} from "@/providers/PlanningTabularProvider";
import { Button, Flex, HorizontalToolbar, useDataTableContext } from "@theorgchartdev/storybook";
import ColumnDisplayMenu from "./ColumnDisplayMenu";
import { useEffect, useMemo } from "react";
import { GetDoc } from "@/Utils/StateLib";
import { CreatePosition } from "./CreatePosition";
import { EditPosition } from "./EditPosition";
import { ClosePosition } from "./ClosePosition";
import { ClonePosition } from "./ClonePosition";
import { UnassignEmployee } from "./UnassignEmployee";
import { ReleaseEmployee } from "./ReleaseEmployee";
import { Divider } from "../Divider";
import {
  handleEditPosition,
  handleCreatePosition,
  handleUnassignEmployee,
  handleReleaseEmployee,
  handleClosePosition,
  hasHolders,
  handleReopenPosition
} from "@/Utils/Table/PosMgmtUtils";
import { appstr } from "@coreapp/utils/appstr";
import { ReopenPosition } from "./ReopenPosition";
import { usePlanManagerContext } from "@/providers/PlanManagerProvider";

const MainToolbarPlanningTabular = () => {
  const {
    setResults,
    searchCtrlRef,
    projectFields,
    holderFields,
    updateState,
    queryOptions,
    state,
    toastHighlightSelectionRef,
    toastHighlightExpansionRef
  } = usePlanningTabularContext();

  const table = useDataTableContext();
  const { selectedPositionsCount, selectionMap } = useTableInstanceContext();
  const { planManager } = usePlanManagerContext();

  // Get selected rows data
  const selectedRows = useMemo(() => {
    return Object.values(selectionMap);
  }, [selectionMap]);

  const isPlanEditable = planManager?.state?.CanUpdatePlan();

  return (
    <HorizontalToolbar
      customToolbarClass="oc-fill-height"
      leftContent={
        <Flex direction="column" gap={12}>
          <Flex gap={12} alignContent="center">
            <CompositeTableSearchControls
              UpdateSearchResultContext={setResults}
              processFullResult
              projectFields={projectFields}
              holderFields={holderFields}
              searchCtrlContext={searchCtrlRef}
              prefixId={"planning-tabular"}
              queryOptions={queryOptions}
              useProjectFieldDefs={true}
              disableRefetchOnSearchFocus
              autoFocus={false}
              onSearchLoading={isLoading => {
                updateState({ isSearchLoading: isLoading });
              }}
              hideAdvancedSearch
            />
            <ColumnDisplayMenu />
          </Flex>
          {isPlanEditable && (
            <Flex gap={12} alignItems="center">
              <EditPosition
                dataTestId={"table-view-edit-position-btn"}
                onClick={() => {
                  toastHighlightSelectionRef.current = null;
                  toastHighlightExpansionRef.current = null;
                  handleEditPosition(selectedRows);
                }}
              />
              <CreatePosition
                dataTestId={"table-view-create-position-btn"}
                onClick={() => {
                  toastHighlightSelectionRef.current = null;
                  toastHighlightExpansionRef.current = null;
                  handleCreatePosition(selectedRows);
                }}
              />
              <Divider />
              <ClonePosition
                dataTestId={"table-view-clone-position-btn"}
                onClick={() => {
                  toastHighlightSelectionRef.current = null;
                  toastHighlightExpansionRef.current = null;
                  handleCreatePosition(selectedRows, true);
                }}
              />
              <UnassignEmployee
                dataTestId={"table-view-unassign-employee-btn"}
                onClick={() => {
                  toastHighlightSelectionRef.current = null;
                  toastHighlightExpansionRef.current = null;
                  handleUnassignEmployee(selectedRows, state.rowSelection);
                }}
              />
              <ReleaseEmployee
                dataTestId={"table-view-release-employee-btn"}
                onClick={() => {
                  toastHighlightSelectionRef.current = null;
                  toastHighlightExpansionRef.current = null;
                  handleReleaseEmployee(selectedRows, state.rowSelection);
                }}
              />
              <Divider />
              <ReopenPosition
                dataTestId={"table-view-reopen-position-btn"}
                onClick={() => {
                  toastHighlightSelectionRef.current = null;
                  toastHighlightExpansionRef.current = null;
                  handleReopenPosition(selectedRows);
                }}
              />
              <ClosePosition
                dataTestId={"table-view-close-position-btn"}
                onClick={() => {
                  toastHighlightSelectionRef.current = null;
                  toastHighlightExpansionRef.current = null;
                  handleClosePosition(selectedRows);
                }}
              />
            </Flex>
          )}
        </Flex>
      }
      size={"large"}
    />
  );
};

export default MainToolbarPlanningTabular;
